import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const ServiceCard = ({ icon, title, description, features }) => {
  return (
    <motion.div
      whileHover={{ y: -5 }}
      className="bg-white rounded-xl shadow-md p-6 hover:shadow-xl transition-all duration-300"
    >
      {/* Icon - All Green */}
      <div className="w-14 h-14 bg-green-600 rounded-lg flex items-center justify-center mb-4">
        <Icon name={icon} size={28} color="white" />
      </div>
      {/* Title */}
      <h3 className="text-xl font-bold text-slate-900 mb-3">
        {title}
      </h3>
      {/* Description */}
      <p className="text-slate-600 mb-4">
        {description}
      </p>
      {/* Features with reassuring phrases */}
      <ul className="space-y-2">
        {features?.map((feature, index) => (
          <li key={index} className="flex items-start gap-2 text-sm text-slate-700">
            <Icon name="Check" size={16} className="text-green-600 flex-shrink-0 mt-0.5" />
            <span>{feature}</span>
          </li>
        ))}
      </ul>
    </motion.div>
  );
};

export default ServiceCard;